// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__39yYe","col":"card_col__37AD8","row":"card_row__1seWE"};